import React from 'react';
import { SpecificationDocument } from '../../../types/index';
import { Button } from '../../../../../components/ui/button'; 
interface DocumentGroupsProps {
  specs: SpecificationDocument[];
  handleDownload: (spec: SpecificationDocument) => void;
}

export const DocumentGroups: React.FC<DocumentGroupsProps> = ({
  specs,
  handleDownload,
}) => {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
      {/* WPS Documents */}
      <div className="space-y-3">
        <h5 className="font-medium flex items-center gap-2">
          <span className="w-2 h-2 bg-blue-500 rounded-full"></span>
          WPS Documents
        </h5>
        <div className="space-y-2">
          {specs.filter(s => s.type === 'WPS').map((spec) => (
            <div key={spec.id} className="flex items-center justify-between p-2 bg-blue-50 rounded-lg">
              <div className="flex items-center gap-3">
                <div className="text-blue-600">
                  <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                  </svg>
                </div>
                <div>
                  <p className="text-sm font-medium text-gray-700">{spec.fileName}</p>
                  <p className="text-xs text-gray-500">{new Date(spec.uploadDate).toLocaleDateString()}</p>
                </div>
              </div>
              <Button
                className="text-blue-600 hover:text-blue-800 bg-transparent"
                onClick={() => handleDownload(spec)}
                title={`Download ${spec.fileName}`}
                aria-label={`Download ${spec.fileName}`}
                variant="outline"
              >
                <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4" />
                </svg>
              </Button>
            </div>
          ))}
        </div>
      </div>

      {/* Drawings */}
      <div className="space-y-3">
        <h5 className="font-medium flex items-center gap-2">
          <span className="w-2 h-2 bg-green-500 rounded-full"></span>
          Drawings
        </h5>
        <div className="space-y-2">
          {specs.filter(s => s.type === 'drawing').map((spec) => (
            <div key={spec.id} className="flex items-center justify-between p-2 bg-green-50 rounded-lg">
              <div className="flex items-center gap-3">
                <div className="text-green-600">
                  <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                  </svg>
                </div>
                <div>
                  <p className="text-sm font-medium text-gray-700">{spec.fileName}</p>
                  <p className="text-xs text-gray-500">{new Date(spec.uploadDate).toLocaleDateString()}</p>
                </div>
              </div>
              <Button
                className="text-green-600 hover:text-green-800 bg-transparent"
                variant="outline"
                onClick={() => handleDownload(spec)}
                title={`Download ${spec.fileName}`}
                aria-label={`Download ${spec.fileName}`}
              >
                <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4" />
                </svg>
              </Button>
            </div>
          ))}
        </div>
      </div>

      {/* Weld Process */}
      <div className="space-y-3">
        <h5 className="font-medium flex items-center gap-2">
          <span className="w-2 h-2 bg-purple-500 rounded-full"></span>
          Weld Process
        </h5>
        <div className="space-y-2">
          {specs.filter(s => s.type === 'weld-process').map((spec) => (
            <div key={spec.id} className="flex items-center justify-between p-2 bg-purple-50 rounded-lg">
              <div className="flex items-center gap-3">
                <div className="text-purple-600">
                  <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                  </svg>
                </div>
                <div>
                  <p className="text-sm font-medium text-gray-700">{spec.fileName}</p>
                  <p className="text-xs text-gray-500">{spec.details?.weldProcess?.processType} - {spec.details?.weldProcess?.wireType}</p>
                </div>
              </div>
              <Button
                className="text-purple-600 hover:text-purple-800 bg-transparent"
                onClick={() => handleDownload(spec)}
                title={`Download ${spec.fileName}`}
                aria-label={`Download ${spec.fileName}`}
                  variant="outline"
              >
                <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4" />
                </svg>
              </Button>
            </div>
          ))}
        </div>
      </div>

      {/* Inspection Procedure */}
      <div className="space-y-3">
        <h5 className="font-medium flex items-center gap-2">
          <span className="w-2 h-2 bg-yellow-500 rounded-full"></span>
          Inspection Procedure
        </h5>
        <div className="space-y-2">
          {specs.filter(s => s.type === 'inspection-procedure').map((spec) => (
            <div key={spec.id} className="flex items-center justify-between p-2 bg-yellow-50 rounded-lg">
              <div className="flex items-center gap-3">
                <div className="text-yellow-600">
                  <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                  </svg>
                </div>
                <div>
                  <p className="text-sm font-medium text-gray-700">{spec.fileName}</p>
                  <p className="text-xs text-gray-500">{spec.details?.inspectionProcedure?.method}</p>
                </div>
              </div>
              <Button
                className="text-yellow-600 hover:text-yellow-800 bg-transparent"
                onClick={() => handleDownload(spec)}
                title={`Download ${spec.fileName}`}
                aria-label={`Download ${spec.fileName}`}
                variant="outline"   
              >
                <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4" />
                </svg>
              </Button>
            </div>
          ))}
        </div>
      </div>

      {/* Acceptance Criteria */}
      <div className="space-y-3">
        <h5 className="font-medium flex items-center gap-2">
          <span className="w-2 h-2 bg-red-500 rounded-full"></span>
          Acceptance Criteria
        </h5>
        <div className="space-y-2">
          {specs.filter(s => s.type === 'acceptance-criteria').map((spec) => (
            <div key={spec.id} className="flex items-center justify-between p-2 bg-red-50 rounded-lg">
              <div className="flex items-center gap-3">
                <div className="text-red-600">
                  <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                  </svg>
                </div>
                <div>
                  <p className="text-sm font-medium text-gray-700">{spec.fileName}</p>
                  <p className="text-xs text-gray-500">{spec.details?.acceptanceCriteria?.standard}</p>
                </div>
              </div>
              <Button
                className="text-red-600 hover:text-red-800 bg-transparent"
                onClick={() => handleDownload(spec)}
                title={`Download ${spec.fileName}`}
                aria-label={`Download ${spec.fileName}`}
                variant="outline"
              >
                <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4" />
                </svg>
              </Button>
            </div>
          ))}
        </div>
      </div>

      {/* Pass Configuration */}
      <div className="space-y-3">
        <h5 className="font-medium flex items-center gap-2">
          <span className="w-2 h-2 bg-indigo-500 rounded-full"></span>
          Pass Configuration
        </h5>
        <div className="space-y-2">
          {specs.filter(s => s.type === 'pass-config').map((spec) => (
            <div key={spec.id} className="flex items-center justify-between p-2 bg-indigo-50 rounded-lg">
              <div className="flex items-center gap-3">
                <div className="text-indigo-600">
                  <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                  </svg>
                </div>
                <div>
                  <p className="text-sm font-medium text-gray-700">{spec.fileName}</p>
                  <p className="text-xs text-gray-500">{spec.details?.passConfig?.numberOfPasses} passes</p>
                </div>
              </div>
              <Button
                className="text-indigo-600 hover:text-indigo-800 bg-transparent"
                onClick={() => handleDownload(spec)}
                title={`Download ${spec.fileName}`}
                aria-label={`Download ${spec.fileName}`}
                variant="outline"   
              >
                <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4" />
                </svg>
              </Button>
            </div>
          ))}
        </div>
      </div>

      {/* Fitment Readings */}
      <div className="space-y-3">
        <h5 className="font-medium flex items-center gap-2">
          <span className="w-2 h-2 bg-pink-500 rounded-full"></span>
          Fitment Readings
        </h5>
        <div className="space-y-2">
          {specs.filter(s => s.type === 'fitment-readings').map((spec) => (
            <div key={spec.id} className="flex items-center justify-between p-2 bg-pink-50 rounded-lg">
              <div className="flex items-center gap-3">
                <div className="text-pink-600">
                  <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                  </svg>
                </div>
                <div>
                  <p className="text-sm font-medium text-gray-700">{spec.fileName}</p>
                  <p className="text-xs text-gray-500">Gap: {spec.details?.fitmentReadings?.gapTolerance}mm</p>
                </div>
              </div>
              <Button
                className="text-pink-600 hover:text-pink-800 bg-transparent"
                onClick={() => handleDownload(spec)}
                title={`Download ${spec.fileName}`}
                  aria-label={`Download ${spec.fileName}`}
                variant="outline"
              >
                <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4" />
                </svg>
              </Button>
            </div>
          ))}
        </div>
      </div>

      {/* Welding Position */}
      <div className="space-y-3">
        <h5 className="font-medium flex items-center gap-2">
          <span className="w-2 h-2 bg-orange-500 rounded-full"></span>
          Welding Position
        </h5>
        <div className="space-y-2">
          {specs.filter(s => s.type === 'welding-position').map((spec) => (
            <div key={spec.id} className="flex items-center justify-between p-2 bg-orange-50 rounded-lg">
              <div className="flex items-center gap-3">
                <div className="text-orange-600">
                  <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                  </svg>
                </div>
                <div>
                  <p className="text-sm font-medium text-gray-700">{spec.fileName}</p>
                  <p className="text-xs text-gray-500">Position: {spec.details?.weldingPosition?.position}</p>
                </div>
              </div>
              <Button
                className="text-orange-600 hover:text-orange-800 bg-transparent"
                onClick={() => handleDownload(spec)}
                title={`Download ${spec.fileName}`}
                  aria-label={`Download ${spec.fileName}`}
                variant="outline"
              >
                <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4" />
                </svg>
              </Button>
            </div>
          ))}
        </div>
      </div>

      {/* Bevel */}
      <div className="space-y-3">
        <h5 className="font-medium flex items-center gap-2">
          <span className="w-2 h-2 bg-teal-500 rounded-full"></span>
          Bevel
        </h5>
        <div className="space-y-2">
          {specs.filter(s => s.type === 'bevel').map((spec) => (
            <div key={spec.id} className="flex items-center justify-between p-2 bg-teal-50 rounded-lg">
              <div className="flex items-center gap-3">
                <div className="text-teal-600">
                  <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                  </svg>
                </div>
                <div>
                  <p className="text-sm font-medium text-gray-700">{spec.fileName}</p>
                  <p className="text-xs text-gray-500">
                    {spec.details?.bevel?.type} - {spec.details?.bevel?.angle}
                  </p>
                </div>
              </div>
              <Button
                className="text-teal-600 hover:text-teal-800 bg-transparent"
                onClick={() => handleDownload(spec)}
                title={`Download ${spec.fileName}`}
                  aria-label={`Download ${spec.fileName}`}
                variant="outline"
              >
                <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4" />
                </svg>
              </Button>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}; 